module.exports = __webpack_public_path__ + "img/seal_healer.05ee5708.svg";